import useDeadlineCountdown from "@root/bet_utils/use_deadline_countdown";
import { BaseBet, PickType, WithSecondsLeft } from "./types";
import { useCallback, useEffect, useMemo, useState } from "react";
import savePicks from "@root/bet_utils/save_picks";
import { createErrorResult, createOkResult } from "@root/bet_utils/DisplaySaveResult";

function useEnrichBet<T extends BaseBet>(initialBet: T, authToken: string, updateBetFromScoringUpdateResponse?: (prev: T, fromScoringUpdate: T) => T) {
  const secondsLeft = useDeadlineCountdown(initialBet.deadline);
  const [ _bet, _setBet ] = useState<T>(initialBet);
  const [ displaySaveResult, setDisplaySaveResult ] = useState<ReturnType<typeof createOkResult>>()

  const changePicks = useCallback((newPicks: PickType<T>[]) => {
    _setBet((prev) => ({ ...prev, picks: newPicks })) // force component update
    savePicks({ bet_id: initialBet.bet_id }, authToken, newPicks,
      /* OK    */ (msg: string) => { setDisplaySaveResult(createOkResult(msg)) },
      /* ERROR */ (errorMsg: string) => { setDisplaySaveResult(createErrorResult(errorMsg)) })
  }, [initialBet.bet_id]);

  useEffect(() => { // close bet on deadline
    if (secondsLeft <= 0 && _bet.event_state === 'open') {
      _setBet((prev) => ({ ...prev, event_state: 'progress' }))
    }
  }, [secondsLeft <= 0, _bet.event_state])

  // todo autoscoreupdate!

  return useMemo(() => ({
    bet: { ..._bet, secondsLeft },
    displaySaveResult,
    changePicks,
  }), [_bet, secondsLeft, displaySaveResult, changePicks]);
}

export type EnrichedBet<T extends BaseBet> = ReturnType<typeof useEnrichBet<T>>

export default useEnrichBet
